<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">Update Complaint Ticket</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-6 sm:col-12 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <template v-if="pageReady">
                    <div class="grid">
                      <div class="col-12">
                        <form
                          ref="observer"
                          tag="form"
                          @submit.prevent="submitForm()"
                          class=""
                          :class="{ card: !isSubPage }"
                        >
                          <div class="surface-100 p-3 text-lg font-bold mb-3">
                            Complaint Information
                          </div>
                          <div class="grid card mx-1">
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Title <em>(optional)</em>
                              </div>
                              <div id="ctrl-title-holder">
                                <InputText
                                  ref="ctrltitle"
                                  v-model.trim="formData.title"
                                  label="Title"
                                  type="text"
                                  pattern="^[A-Za-z0-9-',_. ]+$"
                                  placeholder="Title"
                                  class="w-full"
                                  :class="getErrorClass('title')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('title')"
                                  class="p-error"
                                  >{{ getFieldError("title") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Severity *
                              </div>
                              <div id="ctrl-severity-holder">
                                <Dropdown
                                  class="w-full"
                                  :class="getErrorClass('severity')"
                                  optionLabel="label"
                                  optionValue="value"
                                  ref="ctrlseverity"
                                  v-model="formData.severity"
                                  :options="app.menus.complaintsSeverityItems"
                                  label="Severity"
                                  placeholder="Select ..."
                                >
                                </Dropdown>
                                <small
                                  v-if="isFieldValid('severity')"
                                  class="p-error"
                                  >{{ getFieldError("severity") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Complaint Type *
                              </div>
                              <div id="ctrl-complaint_type-holder">
                                <Dropdown
                                  class="w-full"
                                  :class="getErrorClass('complaint_type')"
                                  optionLabel="label"
                                  optionValue="value"
                                  ref="ctrlcomplaint_type"
                                  v-model="formData.complaint_type"
                                  :options="app.menus.complaintTypeItems"
                                  label="Complaint Type"
                                  placeholder="Select  ..."
                                >
                                </Dropdown>
                                <small
                                  v-if="isFieldValid('complaint_type')"
                                  class="p-error"
                                  >{{ getFieldError("complaint_type") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Site Of Complaint
                              </div>
                              <div id="ctrl-site_of_complaint-holder">
                                <InputText
                                  ref="ctrlsite_of_complaint"
                                  v-model.trim="formData.site_of_complaint"
                                  label="Site Of Complaint"
                                  type="text"
                                  pattern="^[A-Za-z0-9-',_. ]+$"
                                  placeholder="Site Of Complaint"
                                  class="w-full"
                                  :class="getErrorClass('site_of_complaint')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('site_of_complaint')"
                                  class="p-error"
                                  >{{
                                    getFieldError("site_of_complaint")
                                  }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Message or Description *
                              </div>
                              <div id="ctrl-message-holder">
                                <Textarea
                                  :class="getErrorClass('message')"
                                  class="w-full"
                                  ref="ctrlmessage"
                                  rows="3"
                                  pattern="^[A-Za-z0-9-',_. ]+$"
                                  v-model="formData.message"
                                  placeholder="Message or Description"
                                  type="textarea"
                                >
                                </Textarea>
                                <small
                                  v-if="isFieldValid('message')"
                                  class="p-error"
                                  >{{ getFieldError("message") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Solution
                                <em class="text-gray-400">(Editable)</em>
                              </div>
                              <div id="ctrl-solution-holder">
                                <Textarea
                                  :class="getErrorClass('solution')"
                                  class="w-full"
                                  ref="ctrlsolution"
                                  rows="3"
                                  pattern="^[A-Za-z0-9-',_. ]+$"
                                  v-model="formData.solution"
                                  placeholder="Solution"
                                  type="textarea"
                                >
                                </Textarea>
                                <small
                                  v-if="isFieldValid('solution')"
                                  class="p-error"
                                  >{{ getFieldError("solution") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Source Of Complaint
                              </div>
                              <div id="ctrl-source_of_complaint-holder">
                                <Dropdown
                                  class="w-full"
                                  :class="getErrorClass('source_of_complaint')"
                                  optionLabel="label"
                                  optionValue="value"
                                  ref="ctrlsource_of_complaint"
                                  v-model="formData.source_of_complaint"
                                  :options="
                                    app.menus.complaintsSourceOfComplaintItems
                                  "
                                  label="Source Of Complaint"
                                  placeholder="Select ..."
                                >
                                </Dropdown>
                                <small
                                  v-if="isFieldValid('source_of_complaint')"
                                  class="p-error"
                                  >{{
                                    getFieldError("source_of_complaint")
                                  }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-12">
                              <div class="mb-2 font-bold text-sm">
                                Attached Files <em>(optional)</em>
                              </div>
                              <div id="ctrl-attached_files-holder">
                                <div class="mb-3">
                                  <Uploader
                                    :class="getErrorClass('attached_files')"
                                    :auto="true"
                                    :fileLimit="5"
                                    :maxFileSize="3000000"
                                    accept=".jpg,.png,.gif,.jpeg"
                                    :multiple="false"
                                    style="width: 100%"
                                    label="Choose files or drop files here"
                                    upload-path="s3uploader/upload/attached_files"
                                    v-model="formData.attached_files"
                                  ></Uploader>
                                </div>
                                <small
                                  v-if="isFieldValid('attached_files')"
                                  class="p-error"
                                  >{{ getFieldError("attached_files") }}</small
                                >
                              </div>
                            </div>
                          </div>

                          <div class="surface-100 p-3 text-lg font-bold mb-3">
                            Complaint Actions
                          </div>
                          <div class="grid card mx-1">
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Status *
                                <em class="text-gray-400">(Editable)</em>
                              </div>
                              <div id="ctrl-status-holder">
                                <Dropdown
                                  class="w-full"
                                  :class="getErrorClass('status')"
                                  optionLabel="label"
                                  optionValue="value"
                                  ref="ctrlstatus"
                                  v-model="formData.status"
                                  :options="app.menus.complaintsStatusItems"
                                  label="Status"
                                  placeholder="Select a value ..."
                                >
                                </Dropdown>
                                <small
                                  v-if="isFieldValid('status')"
                                  class="p-error"
                                  >{{ getFieldError("status") }}</small
                                >
                              </div>
                            </div>
                            <div
                              v-if="$auth.userDistrict == 'Call Center'"
                              class="col-12 md:col-6"
                            >
                              <div class="mb-2 font-bold text-sm">
                                Action Taken *
                                <em class="text-gray-400">(Editable)</em>
                              </div>
                              <div id="ctrl-action_taken-holder">
                                <Dropdown
                                  class="w-full"
                                  :class="getErrorClass('action_taken')"
                                  optionLabel="label"
                                  optionValue="value"
                                  ref="ctrlaction_taken"
                                  v-model="formData.action_taken"
                                  :options="app.menus.actionTakenItems"
                                  label="Action Taken"
                                  placeholder="Select ..."
                                >
                                </Dropdown>
                                <small
                                  v-if="isFieldValid('action_taken')"
                                  class="p-error"
                                  >{{ getFieldError("action_taken") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">Region</div>
                              <div id="ctrl-assigned_region-holder">
                                <Dropdown
                                  class="w-full"
                                  :class="getErrorClass('assigned_region')"
                                  optionLabel="label"
                                  optionValue="value"
                                  ref="ctrlassigned_region"
                                  v-model="formData.assigned_region"
                                  :options="app.menus.gwclRegionItems"
                                  label="Region"
                                  placeholder="Select ..."
                                  :filter="true"
                                >
                                </Dropdown>
                                <small
                                  v-if="isFieldValid('assigned_region')"
                                  class="p-error"
                                  >{{ getFieldError("assigned_region") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">District</div>
                              <div id="ctrl-assigned_district-holder">
                                <api-data-source
                                  @loaded="formData.assigned_district = ''"
                                  :load-on-mount="false"
                                  :api-path="`components_data/district_option_list?lookup_region=${formData.assigned_region}`"
                                >
                                  <template v-slot="req">
                                    <Dropdown
                                      class="w-full"
                                      :class="
                                        getErrorClass('assigned_district')
                                      "
                                      :loading="req.loading"
                                      optionLabel="label"
                                      optionValue="value"
                                      ref="ctrlassigned_district"
                                      v-model="formData.assigned_district"
                                      :options="
                                        req.response.length > 0
                                          ? req.response
                                          : [
                                              {
                                                label:
                                                  formData.assigned_district,
                                                value:
                                                  formData.assigned_district,
                                              },
                                            ]
                                      "
                                      label="District"
                                      placeholder="Select ..."
                                    >
                                    </Dropdown>
                                    <small
                                      v-if="isFieldValid('assigned_district')"
                                      class="p-error"
                                      >{{
                                        getFieldError("assigned_district")
                                      }}</small
                                    >
                                  </template>
                                </api-data-source>
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Officer Handling
                                <em class="text-gray-400">(Editable)</em>
                              </div>
                              <div id="ctrl-officer_handling-holder">
                                <InputText
                                  ref="ctrlofficer_handling"
                                  v-model.trim="formData.officer_handling"
                                  label="Officer Handling"
                                  type="text"
                                  pattern="^[A-Za-z-' ]+$"
                                  placeholder="Officer Handling"
                                  class="w-full"
                                  :class="getErrorClass('officer_handling')"
                                >
                                </InputText>
                              </div>
                            </div>
                            <!-- <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Assigned To
                              </div>
                              <div id="ctrl-assigned_to-holder">
                                <api-data-source
                                  @loaded="formData.officer_handling = ''"
                                  :load-on-mount="false"
                                  :api-path="`components_data/district_offices_users_option_list?lookup_district=${formData.assigned_district}`"
                                >
                                  <template v-slot="req">
                                    <Dropdown
                                      class="w-full"
                                      :class="getErrorClass('assigned_to', row)"
                                      :loading="req.loading"
                                      optionLabel="label"
                                      optionValue="value"
                                      ref="ctrlassigned_to"
                                      v-model="formData.assigned_to"
                                      :options="req.response"
                                      label="Assigned To"
                                      placeholder="Select ..."
                                    >
                                    </Dropdown>
                                    <small
                                      v-if="isFieldValid('assigned_to', row)"
                                      class="p-error"
                                      >{{
                                        getFieldError("assigned_to", row)
                                      }}</small
                                    >
                                  </template>
                                </api-data-source>
                              </div>
                            </div> -->
                          </div>
                          <!--[form-content-end]-->
                          <div v-if="showSubmitButton" class="text-center my-3">
                            <Button
                              type="submit"
                              label="Update"
                              icon="pi pi-send"
                              class="p-button-rounded"
                              :loading="saving"
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </template>
                  <template v-if="loading">
                    <div class="p-3 text-center">
                      <ProgressSpinner style="width: 50px; height: 50px" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { required, numeric } from "@/services/validators";
import { useApp } from "@/composables/app.js";
import { useAuth } from "@/composables/auth";
import { useEditPage } from "@/composables/editpage.js";
const props = defineProps({
  id: [String, Number],
  pageName: {
    type: String,
    default: "complaints",
  },
  routeName: {
    type: String,
    default: "complaintsedit",
  },
  pagePath: {
    type: String,
    default: "complaints/edit",
  },
  apiPath: {
    type: String,
    default: "complaints/edit",
  },
  submitButtonLabel: {
    type: String,
    default: "Update",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  msgAfterUpdate: {
    type: String,
    default:
      "Ticket update successsfully. Refresh page to see updated information",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp();
const auth = useAuth();
const formDefaultValues = Object.assign(
  {
    title: "",
    severity: "",
    complaint_type: "",
    site_of_complaint: "",
    message: "",
    solution: "",
    source_of_complaint: "",
    status: "",
    action_taken: "",
    assigned_region: "",
    assigned_district: "",
    officer_handling: "",
    assigned_to: "",
    attached_files: "",
  },
  props.pageData
);
const formData = reactive({ ...formDefaultValues });
function onFormSubmited(response) {
  app.flashMsg(props.msgAfterUpdate, null, null, 8000);
  // if (props.redirect) app.navigateTo(`/complaints`);
}
const rules = computed(() => {
  return {
    title: {},
    severity: { required },
    complaint_type: { required },
    site_of_complaint: {},
    message: { required },
    solution: {},
    source_of_complaint: {},
    status: { required },
    action_taken: {},
    assigned_region: {},
    assigned_district: {},
    officer_handling: {},
    assigned_to: { numeric },
    attached_files: {},
  };
});
const v$ = useVuelidate(rules, formData); //form validation
const page = useEditPage(props, formData, v$, onFormSubmited);
//page state
const {
  submitted, // form api submitted state - Boolean
  saving, // form api submiting state - Boolean
  loading, // form data loading state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const {
  load, // get editable form data from api
  submitForm, // submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname)
  getFieldError, //  get validation error message - args(fieldname)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;
onMounted(() => {
  const pageTitle = "Update Ticket";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped>
.p-disabled,
.p-component:disabled {
  opacity: 0.9 !important;
}
</style>
